import { common } from './common'
import { facilitator } from './facilitator'
import { bus } from './bus'
import { public_ } from './public'
import { feedbackForms } from './feedbackForms'
import { project } from './project'
import { tags } from './tags'
import { pins } from './pins'
import { contentRating } from './contentRating'
import { approvalStatus } from './approvalStatus'
import { errors } from './errors'
import { emailTemplates } from './emailTemplates'
import { formBuilder } from './formBuilder'
import { demo } from './demo'
import { projectAdmin } from './projectAdmin'
import { wanderMaker } from './wanderMaker'
import { postbox } from './postbox'
import { accountability } from './accountability'
import { superAdminDashboard } from './superAdminDashboard'
import { orgFiles } from './orgFiles'
import { auth } from './auth'
import { bulletin } from './bulletin'
import { campaign } from './campaign'
import { audienceGroup } from './audienceGroup'
import { subscriber } from './subscriber'
import { projectInquiry } from './projectInquiry'
import { leadPipeline } from './leadPipeline'
import { document } from './document'
import { workshop } from './workshop'
import { loading } from './loading'
import { forms } from './forms'
import { newsletter } from './newsletter'
import { wanderWriter } from './wanderWriter'
import { commissions } from './commissions'
import { moderation } from './moderation'
import { appSettings } from './appSettings'
import { livingWageHours } from './livingWageHours'
import { finance } from './finance'
import { teamUpdates } from './teamUpdates'
import { meetings } from './meetings'
import { occasion } from './occasion'
import { workstreamTimeline } from './workstreamTimeline'
import { userAccess } from './userAccess'
import { orphanedFiles } from './orphanedFiles'
import { jobs } from './jobs'
import { facilitatorContracts } from './facilitatorContracts'
import { workStreamSenseMaking } from './workStreamSenseMaking'
import { roleDashboards } from './roleDashboards'
import { consent } from './consent'
import { workExperience } from './workExperience'

const en = {
  common,
  facilitator,
  bus,
  public: public_,
  feedbackForms,
  project,
  tags,
  pins,
  contentRating,
  approvalStatus,
  errors,
  emailTemplates,
  formBuilder,
  demo,
  projectAdmin,
  wanderMaker,
  postbox,
  accountability,
  superAdminDashboard,
  orgFiles,
  auth,
  bulletin,
  campaign,
  audienceGroup,
  subscriber,
  projectInquiry,
  leadPipeline,
  document,
  workshop,
  loading,
  forms,
  newsletter,
  wanderWriter,
  commissions,
  moderation,
  appSettings,
  livingWageHours,
  finance,
  teamUpdates,
  meetings,
  occasion,
  workstreamTimeline,
  userAccess,
  orphanedFiles,
  jobs,
  facilitatorContracts,
  workStreamSenseMaking,
  roleDashboards,
  consent,
  workExperience,
}

export default en
export type Translations = typeof en
